<div>
    <h1 class="category-title dashboard-header-item">Performance Dashboard</h1>
</div>
<div class="dashboard-container custom-vertical-scroll">
    <!-- Skeleton Overlay (only shown when loading) -->

    <div *ngIf="loading" class="skeleton-overlay">
        <!-- Left: Filters -->
        <div class="skeleton-filters-panel">
            <div class="skeleton-filter-header">
                <div class="skeleton-h3"></div>
                <div class="skeleton-filter-actions">
                    <div class="skeleton-btn"></div>
                    <div class="skeleton-btn"></div>
                </div>
            </div>
            <mat-divider> </mat-divider>

            <!-- Product Hierarchy -->
            <div class="skeleton-filter-group">
                <div class="skeleton-h4"></div>
                <div class="skeleton-input"></div>
                <div class="skeleton-input"></div>
                <div class="skeleton-input"></div>
                <div class="skeleton-input"></div>
                <!-- <div class="skeleton-input"></div> -->
            </div>

            <mat-divider class="dashed-divider"> </mat-divider>

            <!-- Location Hierarchy -->
            <div class="skeleton-filter-group">
                <div class="skeleton-h4"></div>
                <div class="skeleton-input"></div>
                <div class="skeleton-input"></div>
                <div class="skeleton-input"></div>
            </div>

            <mat-divider class="dashed-divider"> </mat-divider>

            <!-- Season -->
            <div class="skeleton-filter-group">
                <div class="skeleton-h4"></div>
                <div class="skeleton-input"></div>
            </div>

            <mat-divider class="dashed-divider"> </mat-divider>

            <!-- Size Range -->
            <div class="skeleton-filter-group">
                <div class="skeleton-h4"></div>
                <div class="skeleton-input"></div>
            </div>
        </div>

        <!-- Right: Main Content -->
    </div>
    <!-- Filters Panel -->
    <div class="filters-wrapper custom-vertical-scroll" *ngIf="!loading">
        <div class="filters-panel">
            <div class="filter-header">
                <h3>Filters</h3>
                <div class="filter-actions">
                    <button mat-button (click)="clearFilters()" class="filter-btn">Clear</button>
                    <button mat-raised-button color="accent" (click)="applyFilters()" class="filter-btn">Apply</button>
                </div>
            </div>
            <mat-divider> </mat-divider>

            <div class="filter-section">
                <h4>PRODUCT HIERARCHY</h4>
                <!-- Department -->
                <mat-form-field class="col-12">
                    <mat-label>{{ prod_labels[0] }}</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="departmentAutocomplete"
                        [value]="filters.department"
                        (input)="onDepartmentInputChange($event)"
                        [disabled]="departmentLoading"
                    />
                    <mat-spinner
                        *ngIf="departmentLoading"
                        matSuffix
                        diameter="20"
                        style="display: inline-block; margin-right: 10px"
                    ></mat-spinner>
                    <mat-autocomplete
                        #departmentAutocomplete="matAutocomplete"
                        (optionSelected)="onDepartmentOptionSelected($event.option.value)"
                    >
                        <mat-option *ngFor="let department of filteredDepartments" [value]="department">
                            {{ department }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <!-- Class -->
                <mat-form-field class="col-12">
                    <mat-label>{{ prod_labels[1] }}</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="classAutocomplete"
                        [value]="filters.class"
                        (input)="onClassInputChange($event)"
                        [disabled]="filteredClasses.length === 0 || classLoading"
                    />
                    <mat-spinner
                        *ngIf="classLoading"
                        matSuffix
                        diameter="20"
                        style="display: inline-block; margin-right: 10px"
                    ></mat-spinner>
                    <mat-autocomplete
                        #classAutocomplete="matAutocomplete"
                        (optionSelected)="onClassOptionSelected($event.option.value)"
                    >
                        <mat-option *ngFor="let classItem of filteredClasses" [value]="classItem">
                            {{ classItem }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <!-- Subclass -->
                <mat-form-field class="col-12">
                    <mat-label>{{ prod_labels[2] }}</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="subclassAutocomplete"
                        [value]="filters.subclass"
                        (input)="onSubclassInputChange($event)"
                        [disabled]="filteredSubclasses.length === 0 || subclassLoading"
                    />
                    <mat-spinner
                        *ngIf="subclassLoading"
                        matSuffix
                        diameter="20"
                        style="display: inline-block; margin-right: 10px"
                    ></mat-spinner>
                    <mat-autocomplete
                        #subclassAutocomplete="matAutocomplete"
                        (optionSelected)="onSubclassOptionSelected($event.option.value)"
                    >
                        <mat-option *ngFor="let subclass of filteredSubclasses" [value]="subclass">
                            {{ subclass }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <!-- Style -->
                <mat-form-field class="col-12">
                    <mat-label>{{ prod_labels[3] }}</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="styleAutocomplete"
                        [value]="filters.style"
                        (input)="onStyleInputChange($event)"
                        [disabled]="filteredStyles.length === 0"
                    />
                    <mat-spinner
                        *ngIf="styleLoading"
                        matSuffix
                        diameter="20"
                        style="display: inline-block; margin-right: 10px"
                    ></mat-spinner>
                    <mat-autocomplete
                        #styleAutocomplete="matAutocomplete"
                        (optionSelected)="onStyleOptionSelected($event.option.value)"
                    >
                        <mat-option *ngFor="let style of filteredStyles" [value]="style">
                            {{ style }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <!-- Style-Color -->
                <!-- <mat-form-field class="col-12">
                    <mat-label>Style-Color</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="styleColorAutocomplete"
                        [value]="filters.styleColor"
                        (input)="onStyleColorInputChange($event)"
                        [disabled]="filteredStyleColors.length === 0"
                    />
                    <mat-autocomplete
                        #styleColorAutocomplete="matAutocomplete"
                        (optionSelected)="onStyleColorOptionSelected($event.option.value)"
                    >
                        <mat-option *ngFor="let styleColor of filteredStyleColors" [value]="styleColor">
                            {{ styleColor }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field> -->
            </div>
            <mat-divider class="dashed-divider"> </mat-divider>

            <div class="filter-section">
                <h4>LOCATION HIERARCHY</h4>
                <!-- Channel -->
                <mat-form-field class="col-11">
                    <mat-label>Channel</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="channelAutocomplete"
                        [value]="filters.channel"
                        (input)="onChannelInputChange($event)"
                        [disabled]="channelLoading"
                    />
                    <mat-spinner
                        *ngIf="channelLoading"
                        matSuffix
                        diameter="20"
                        style="display: inline-block; margin-right: 10px"
                    ></mat-spinner>
                    <mat-autocomplete
                        #channelAutocomplete="matAutocomplete"
                        (optionSelected)="onChannelOptionSelected($event.option.value)"
                    >
                        <mat-option *ngFor="let channel of filteredChannels" [value]="channel">
                            {{ channel }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <!-- Custom Store List -->
                <div class="custom-store-list">
                    <mat-form-field class="col-12">
                        <mat-label>Custom Store List</mat-label>
                        <input
                            matInput
                            placeholder="All (type to search)"
                            [matAutocomplete]="customStoreListAutocomplete"
                            [value]="filters.customStoreList"
                            (input)="onCustomStoreListInputChange($event)"
                            [disabled]="customStoreListLoading"
                        />
                        <mat-spinner
                            *ngIf="customStoreListLoading"
                            matSuffix
                            diameter="20"
                            style="display: inline-block; margin-right: 10px"
                        ></mat-spinner>
                        <mat-autocomplete
                            #customStoreListAutocomplete="matAutocomplete"
                            (optionSelected)="onCustomStoreListOptionSelected($event.option.value)"
                        >
                            <mat-option
                                *ngFor="let customStoreList of filteredCustomStoreLists"
                                [value]="customStoreList"
                            >
                                {{ customStoreList }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <button
                        id="custom-store-list-settings"
                        #tooltip="matTooltip"
                        mat-icon-button
                        id="open-custom-store-list-btn"
                        matTooltip="Create Custom Store List"
                        [matTooltipClass]="'below'"
                        color="accent"
                        (click)="onOpenDrillInFiltersModal($event)"
                    >
                        <span class="material-icons launch-icon align-icon-center"> launch </span>
                    </button>
                </div>

                <!-- Store ID -->
                <mat-form-field class="col-11">
                    <mat-label>Store ID</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="storeIdAutocomplete"
                        [value]="filters.storeId"
                        (input)="onStoreIdInputChange($event)"
                        [disabled]="filteredStoreIds.length === 0"
                    />
                    <mat-autocomplete
                        #storeIdAutocomplete="matAutocomplete"
                        (optionSelected)="onStoreIdOptionSelected($event.option.value)"
                    >
                        <mat-option *ngFor="let storeId of filteredStoreIds" [value]="storeId">
                            {{ storeId }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <mat-divider class="dashed-divider"> </mat-divider>
            <div class="filter-section">
                <h4>SEASON</h4>
                <mat-form-field class="col-12">
                    <mat-label>Historical Selling Season</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="seasonAutocomplete"
                        [value]="filters.season"
                        (input)="onSeasonInputChange($event)"
                    />
                    <mat-autocomplete
                        #seasonAutocomplete="matAutocomplete"
                        (optionSelected)="onSeasonOptionSelected($event.option.value)"
                    >
                        <mat-option *ngFor="let season of filteredSeasons" [value]="season">
                            {{ season }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <mat-divider class="dashed-divider"> </mat-divider>
            <div class="filter-section">
                <h4>SIZE RANGE NAME</h4>
                <mat-form-field class="col-12">
                    <mat-label>Size Range</mat-label>
                    <input
                        matInput
                        placeholder="All (type to search)"
                        [matAutocomplete]="sizeRangeAutocomplete"
                        [value]="selectedSizeRangesDisplay"
                        (input)="onSizeRangeInputChange($event)"
                    />
                    <mat-autocomplete
                        #sizeRangeAutocomplete="matAutocomplete"
                        (optionSelected)="$event.option.deselect()"
                    >
                        <mat-option *ngFor="let size of filteredSizeRanges" [value]="size">
                            <mat-checkbox
                                [checked]="selectedSizeRanges.includes(size)"
                                (click)="toggleSizeRange(size); $event.stopPropagation()"
                            >
                                {{ size }}
                            </mat-checkbox>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
    </div>

    <!-- Main Content Area -->
    <div class="skeleton-main-content" *ngIf="dashboardLoading">
        <!-- KPI Cards -->
        <div class="skeleton-kpi-row">
            <div class="skeleton-kpi-card"></div>
            <div class="skeleton-kpi-card"></div>
            <div class="skeleton-kpi-card"></div>
            <div class="skeleton-kpi-card"></div>
            <div class="skeleton-kpi-card"></div>
        </div>

        <!-- Charts -->
        <div class="skeleton-charts-row">
            <div class="skeleton-chart"></div>
            <div class="skeleton-chart"></div>
        </div>

        <!-- Table -->
        <div class="skeleton-table">
            <div class="skeleton-table-title"></div>
            <div class="skeleton-table-body">
                <div class="skeleton-table-header"></div>
                <div class="skeleton-table-row"></div>
                <div class="skeleton-table-row"></div>
                <div class="skeleton-table-row"></div>
                <div class="skeleton-table-row"></div>
                <div class="skeleton-table-row"></div>
                <div class="skeleton-table-row"></div>
            </div>
        </div>
    </div>
    <div class="main-content" *ngIf="!dashboardLoading && performanceData">
        <!-- KPI Cards -->
        <div class="kpi-cards">
            <div
                class="kpi-card"
                (click)="openKPIDetail('inventoryEfficiency', performanceData.kpis.inventory_efficiency.row_data)"
            >
                <h5>Inventory Efficiency</h5>
                <div class="kpi-value">{{ performanceData.kpis.inventory_efficiency.value }}</div>
                <div class="kpi-change">{{ performanceData.kpis.inventory_efficiency.change }}</div>
            </div>
            <div
                class="kpi-card"
                (click)="openKPIDetail('regPriceSellThrough', performanceData.kpis.regular_price_sell_through.row_data)"
            >
                <h5>Reg Price Sell-Through</h5>
                <div class="kpi-value">{{ performanceData.kpis.regular_price_sell_through.value }}</div>
                <div class="kpi-change">{{ performanceData.kpis.regular_price_sell_through.change }}</div>
            </div>
            <div
                class="kpi-card"
                (click)="openKPIDetail('profilePrecision', performanceData.kpis.profile_precision_index.row_data)"
            >
                <h5>Profile Precision Index</h5>
                <div class="kpi-value">{{ performanceData.kpis.profile_precision_index.value }}</div>
                <div class="kpi-change">{{ performanceData.kpis.profile_precision_index.change }}</div>
            </div>
            <div
                class="kpi-card"
                (click)="openKPIDetail('packAlignment', performanceData.kpis.pack_alignment_index.row_data)"
            >
                <h5>Pack Alignment Index</h5>
                <div class="kpi-value">{{ performanceData.kpis.pack_alignment_index.value }}</div>
                <div class="kpi-change">{{ performanceData.kpis.pack_alignment_index.change }}</div>
            </div>
            <div
                class="kpi-card"
                (click)="openKPIDetail('profileAcceptance', performanceData.kpis.profile_acceptance.row_data)"
            >
                <h5>Profile Acceptance</h5>
                <div class="kpi-value">{{ performanceData.kpis.profile_acceptance.value }}</div>
                <div class="kpi-change">{{ performanceData.kpis.profile_acceptance.change }}</div>
            </div>
        </div>

        <!-- Charts Section -->
        <div class="charts-section">
            <!-- Chart 1: Seasonal Lost Sales vs Overstock (trend) -->
            <div class="chart-card">
                <div class="title-with-legend" (click)="openBarChartDetail()">
                    <p>Seasonal Lost Sales vs Overstock (trend)</p>
                    <div class="legend">
                        <span>
                            <div class="legend-color" style="background-color: #007bff"></div>
                            Lost Sales
                        </span>
                        <span>
                            <div class="legend-color" style="background-color: #333"></div>
                            Overstock
                        </span>
                    </div>
                </div>
                <p-chart
                    (click)="openBarChartDetail()"
                    type="bar"
                    id="seasonal-lost-sales-chart"
                    [data]="seasonalLostSalesData"
                    [options]="seasonalLostSalesOptions"
                    [width]="300"
                    [height]="200"
                ></p-chart>
            </div>

            <!-- Chart 2: Profile vs Demand by Size -->
            <div class="chart-card">
                <p
                    *ngIf="!filters.subclass || selectedSizeRanges[0] === 'All'"
                    style="text-align: center; margin: 20px"
                >
                    Select a {{ prod_labels[prod_labels.length - 1] }} in Product Hierarchy and a Size Range to view
                    size-level profile precision vs demand.
                </p>

                <div class="title-with-legend" (click)="openLineChartDetail()" *ngIf="profilePrecisionData">
                    <p>Profile vs Demand by Size</p>
                </div>

                <p-chart
                    (click)="openLineChartDetail()"
                    *ngIf="profilePrecisionData"
                    type="line"
                    id="profile-precision-chart"
                    [data]="profilePrecisionData"
                    [options]="profilePrecisionOptions"
                    [width]="300"
                    [height]="200"
                ></p-chart>
            </div>
        </div>

        <!-- Table Section -->
        <div class="table-container">
            <div class="table-section">
                <p>Regular Price Sell-Through by Size (with Weeks OOS)</p>
                <p *ngIf="selectedSizeRanges[0] == 'All'">* Requires a Size Range Name or Size to be selected</p>
                <div *ngIf="selectedSizeRanges[0] != 'All'">
                    <ag-grid-angular
                        (click)="openFullTable()"
                        [columnDefs]="sizeSellThroughColumnDefs"
                        [rowData]="sizeSellThroughData"
                        class="ag-theme-alpine ag-grid-container"
                        [gridOptions]="sizeSellThroughGridOptions"
                    ></ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>
